
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcAdviceMenuItem as ObcAdviceMenuItemElement} from '@oicl/openbridge-webcomponents/dist/components/advice-menu-item/advice-menu-item.js';
 
 
 

 
 export const ObcAdviceMenuItem = createComponent({
   react: React,
   tagName: 'obc-advice-menu-item',
   elementClass: ObcAdviceMenuItemElement,
   events: {
     
     onPrimaryActionClick: 'primary-action-click' as EventName<CustomEvent<void>>,
     onSecondaryActionClick: 'secondary-action-click' as EventName<CustomEvent<void>>,
     onItemClick: 'item-click' as EventName<CustomEvent<{open: boolean}>>,
   }
  });
 
 